let configs = {
    clientFornInputsArr:[
        {key: 'companyName', value: 'Company Name', isRequired:true},
        {key: 'companyAddress', value: 'Company Address', isRequired:true},
        {key: 'companyEmail', value: 'Company Email', isRequired:true},
        {key: 'companyContactPerson', value: 'Contact Person', isRequired:false},
        {key: 'companyContactPersonDesignation', value: 'Contact Person Designation', isRequired:false},
        {key: 'companyContactPersonMobile', value: 'Contact Person Mobile', isRequired:false},
        {key: 'companyContactPersonEmail', value: 'Contact Person Email', isRequired:false},
    ],

    vacsplFornInputsArr:[
        {key: 'serviceEngineername', value: 'Service Engineer', isRequired:true},
        {key: 'serviceEngineerNumber', value: 'Contact Number', isRequired:true},
        {key: 'serviceEngineerEmail', value: 'Email', isRequired:true},
        {key: 'dateOfService', value: 'Date of Inspection', isRequired:true},
    ]
}

export default configs;